import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import { Dialog } from '@material-ui/core';
import { EAA_Btn } from '~/components/EditAndAddItem';
import { rightColor } from '~/components/EditAndAddItem/common';

class AddUser extends Component {
  _check=() => {
    const { sucFunc, clearKey, result, resKey, failFunc } = this.props;
    const resBody = result(resKey) || {};
    if (resBody.status === '200') { clearKey(resKey); sucFunc(); } else { clearKey(resKey); failFunc(); };
  }

   renderDialog=() => {
     const { result, resKey } = this.props;
     const resBody = result(resKey) || {};
     return (
       <div style={{ width: 515, height: 458, backgroundColor: 'white', borderRadius: 39, alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
         <svg style={{ marginTop: 64, marginBottom: 8 }} width="158" height="211" viewBox="0 0 158 211" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path d="M158 50.253V52.75H105.333V0H107.826C110.445 0 112.957 1.04222 114.809 2.89672L155.108 43.2591C156.96 45.1142 158 47.6299 158 50.253ZM102.042 65.9375H158V201.109C158 206.572 153.579 211 148.125 211H9.875C4.42112 211 0 206.572 0 201.109V9.89062C0 4.42812 4.42112 0 9.875 0H92.1667V56.0469C92.1667 61.4867 96.6104 65.9375 102.042 65.9375ZM128.908 111.159L117.318 99.456C115.398 97.517 112.271 97.5043 110.335 99.428L66.7056 142.775L47.7868 123.673C45.8665 121.734 42.7398 121.721 40.8039 123.645L29.1197 135.254C27.1838 137.178 27.1711 140.309 29.0918 142.248L63.0786 176.564C64.9989 178.503 68.1252 178.515 70.0611 176.592L128.88 118.153C130.816 116.229 130.829 113.098 128.908 111.159Z" fill="#5A397E" />
         </svg>

         <div style={{ fontSize: 25, marginBottom: 52 }}>
           {resBody.status && resBody.status === '200' && '資料新增成功'}
           {resBody.status && resBody.status !== '200' && (resBody.message || '資料新增失敗')}
         </div>
         <div style={{ display: 'flex' }}>
           <EAA_Btn text='確認' style={{ height: 47, width: 155 }} backgroundColor={rightColor} onClick={this._check} />
         </div>
       </div>
     );
   }

   render () {
     const { result, resKey } = this.props;
     const resBody = result(resKey) || {};
     return (
       <Dialog
         PaperComponent={this.renderDialog}
         open={Object.keys(resBody).length > 0}
       />
     );
   }
}

const mapStateToProps = state => ({
  result: key => state.data[key],
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
});

const App_AddUser = connect(mapStateToProps, mapDispatchToProps)(AddUser);
const App = (props = { sucFunc: () => {}, failFunc: () => {}, resKey: '' }) => <App_AddUser {...props} />;
export default App;
